import {CTA, styled} from '@volkswagen-onehub/components-core';
import React, {useRef, useEffect, KeyboardEvent} from 'react';

const LeftDiv = styled.div`
  justify-content: left;
  display: flex;
`;

const DealerCrd = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 10px;
  font-size: var(--textappearances-copy200-fontsize);
  line-height: var(--textappearances-copy200-lineheight);
  letter-spacing: var(--textappearances-copy200-letterspacing);

  .custom-control {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    padding: 0;
  }

  // .btn-pill {
  //   font-size: var(--textappearances-copy150-fontsize) !important;
  //   line-height: var(--textappearances-copy150-lineheight);
  //   letter-spacing: var(--textappearances-copy150-letterspacing);
  //   &:focus {
  //     outline: #4CC7F4 solid 2px;
  //     outline-offset: 2px;
  //   }
  // }

  .row {
    position: relative;
  }
  input[type='radio'] {
    width: 1px;
    height: 1px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .dealer-label {
    display: flex;
    align-items: center;
    text-align: left;
    font-weight: bold;
    &:focus {
      outline: 2px solid #4cc7f4;
      outline-offset: 2px;
    }
  }
  .dealer-radio {
    margin-right: 12px;
    width: 24px;
    height: 24px;
    position: relative;
    &::before,
    &::after {
      content: ' ';
      width: 24px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
    }
    &::before {
      border: 1px solid #001e50;
      background-color: #fff;
    }
  }
  input[type='radio'] {
    &:checked {
      & ~ .dealer-label {
        .dealer-radio {
          &::after {
            background-image: none;
            background-color: #001e50;
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    &:focus {
      & ~ .dealer-label {
        outline: 2px solid #4cc7f4;
        outline-offset: 2px;
      }
    }
  }

  .row {
    // margin: 0 15px;
    font-family: $VWText;
    justify-content: left;
    transition: all 0.2s ease-in-out 0s;

    &.name {
      color: rgb(0, 30, 80);

      label,
      span {
        cursor: pointer;
      }

      &:hover {
        color: rgb(26, 115, 232);
      }

      &:focus {
        outline: 2px solid #4cc7f4;
        outline-offset: 2px;
      }
    }

    &.name,
    &.phone {
      font-family: $VWText-Bold;
    }

    &.distance i {
      margin-right: 10px;
    }

    &.phone {
      text-align: left;
      display: flex;
      text-decoration: none;
      margin-top: 10px;
      font-weight: bold;

      a {
        display: block;
        flex: 0 0 auto;
        text-align: left;
        color: rgb(0, 30, 80) !important;
        border-bottom: 1px solid rgb(0, 30, 80);
        transition: all 0.2s ease-in-out 0s;
        position: relative;
        text-decoration: none;
        &:focus {
          &::before {
            content: '';
            width: calc(100% + 12px);
            height: calc(100% + 12px);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border: #4cc7f4 solid 2px;
          }
          outline: none;
          // outline: 2px solid #4cc7f4;
          // outline-offset: 2px;
        }
        &:hover {
          text-decoration: none;
          border-bottom: 0px solid rgb(0, 30, 80);
        }
      }
    }

    &.address {
      text-align: left;
    }

    &.cta {
      margin-top: 10px;
      text-align: right;
    }
  }
`;

type Props = {
  name: string;
  id: string | number;
  dealer: any;
  locale: any;
  selectedDealer: any;
  onDealerSelect: () => void;
  requestLabel: string;
  keyDown: (e: KeyboardEvent) => void;
  searchMade: boolean;
  invalidZip: boolean;
  firstDealer: string;
  tracking: any;
};

const DealerCard = (props: Props) => {
  const {
    dealer,
    selectedDealer,
    locale,
    requestLabel,
    onDealerSelect,
    keyDown,
    searchMade,
    invalidZip,
    firstDealer,
    tracking,
  } = props;

  const cardRef = useRef<HTMLInputElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const dealerURL =
    locale === 'fr' && dealer.service.website_fr
      ? dealer.service.website_fr
      : dealer.service.website_en;

  useEffect(() => {
    if (selectedDealer === dealer.id) {
      const node = buttonRef.current;
      if (node !== null) {
        node.focus();
      }
    }
  }, [selectedDealer, dealer.id]);

  const requestClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    const data = {
      eventInfo: {
        brand: 'passenger',
      },
      environment: {
        featureAppId: 'TireStorageLocator-D6-CA',
      },
      partner: {
        informationBnr: dealer.dealer_id,
        informationName: dealer.name,
        informationDepartment: undefined,
        informationZIP: dealer.postal,
        onlinePaymentOption: undefined,
        appointmentSystemName: undefined,
        appointmentSystemUtilization: false,
      },
      process: {
        StepName: 'Dealer Request',
      },
      link: {
        url: dealerURL,
        name: dealer.name,
      },
    };

    tracking.track('VWBasic_DealerButton_Click', data);

    window.open(e.currentTarget.getAttribute('href') ?? '', '_blank');
  };

  const phoneClick = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    const data = {
      eventInfo: {
        brand: 'passenger',
      },
      environment: {
        featureAppId: 'TireStorageLocator-D6-CA',
      },
      partner: {
        informationBnr: dealer.dealer_id,
        informationName: dealer.name,
        informationDepartment: undefined,
        informationZIP: dealer.postal,
        onlinePaymentOption: undefined,
        appointmentSystemName: undefined,
        appointmentSystemUtilization: false,
      },
      process: {
        StepName: 'Dealer Phone Number',
      },
      phone: {
        Name: dealer.name,
        Number: dealer.phone,
      },
    };

    tracking.track('VWBasic_Phonenumber_Click', data);

    window.open(e.currentTarget.getAttribute('href') ?? '', '_self');
  };
  useEffect(() => {
    if (searchMade && !invalidZip && firstDealer === dealer.id) {
      const node = cardRef.current;
      if (node !== null) {
        node.focus();
        const y = node.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    }
  }, [searchMade, invalidZip, firstDealer, dealer.id]);

  return (
    <DealerCrd>
      <div className="name row">
        <input
          type="radio"
          name="dealers"
          id={`dealer-${dealer.id}`}
          value={dealer.id}
          checked={selectedDealer === dealer.id}
          onChange={onDealerSelect}
          ref={cardRef}
          aria-label={dealer.name}
          tabIndex={-1}
          aria-hidden={true}
        />
        <label
          role="radio"
          className="dealer-label"
          htmlFor={`dealer-${dealer.id}`}
          tabIndex={0}
          onKeyDown={keyDown}
          aria-checked={selectedDealer === dealer.id}
        >
          <div className="dealer-radio"></div>
          {dealer.name}
        </label>
      </div>
      <div className="address row">
        {dealer.address} <br /> {dealer.city} {dealer.province} {dealer.postal}
      </div>
      <div className="phone row">
        <a
          href={`tel:${dealer.phone}`}
          aria-label={`Call dealer at ${dealer.phone}`}
          onClick={(e: React.SyntheticEvent<HTMLAnchorElement>) => {
            phoneClick(e);
          }}
        >
          <i className="icon-phone"></i>
          {dealer.phone}
        </a>
      </div>
      {selectedDealer === dealer.id && dealerURL ? (
        <LeftDiv className="cta row">
          <CTA
            emphasis="primary"
            tag="a"
            href={dealerURL}
            aria-label={`${requestLabel} with ${dealer.name}`}
            ref={buttonRef}
            target="_blank"
            onClick={(e) => requestClick(e)}
          >
            {requestLabel}
          </CTA>
        </LeftDiv>
      ) : (
        <div className="cta" hidden={true}></div>
      )}
      <hr></hr>
    </DealerCrd>
  );
};

export default DealerCard;
